<template>
	<div class="newsDetails">
		<div class="header"></div>
		<div class="content">
			<div class="inner">
				<!-- 面包屑导航区域 -->
				<!-- <el-breadcrumb separator="/">
					<el-breadcrumb-item :to="{ path: '/newsAndTrends' }"
						>新闻资讯</el-breadcrumb-item
					>
					<el-breadcrumb-item>新闻内容</el-breadcrumb-item>
				</el-breadcrumb> -->
				<div class="content-text" v-show="!isEmpty">
					<div class="content-title">
						{{ data.title }}
					</div>
					<div class="content-txt">
						<time>{{ data.time }}</time>
						<!-- <span>编辑人：{{ data.editor }}</span> -->
					</div>
					<quill-editor
						v-model="content"
						id="textCenter"
						ref="myQuillEditor"
					>
					</quill-editor>
					<!-- <div id="textCenter"></div> -->
				</div>
				<div class="empty" v-show="isEmpty">
					<img v-lazy="nullImg" :key="nullImg" alt="请求失败" />
					<span>网络开小差了,请求失败</span>
				</div>
			</div>
		</div>
		<div class="left"></div>
		<div class="right"></div>
	</div>
</template>

<script>
import { getNewsDetails } from '@/network/home/index'
export default {
	name: 'newsDetails',
	data() {
		return {
			nullImg: require('@/assets/img/04_null.png'),
			data: '',
			content: '',
			isEmpty: true,
			options: [],
		}
	},
	watch: {},
	components: {},
	computed: {
		editor() {
			return this.$refs.myQuillEditor.quill
		},
	},
	mounted() {
		if (this.$route.query.id) {
			this.j_getNewDetails(this.$route.query.id)
		}
	},
	methods: {
		init() {
			let htmlWidth = document.querySelector('html').offsetWidth
			let contentWidth = ''
			if (htmlWidth > 768) {
				contentWidth = htmlWidth * 0.66
			} else {
				contentWidth = htmlWidth * 0.9
			}
			let imgAll = document
				.getElementById('textCenter')
				.querySelectorAll('img')
			for (let i = 0; i < imgAll.length; i++) {
				imgAll[i].onload = function () {
					if (imgAll[i].clientWidth > contentWidth) {
						imgAll[i].style.width = '100%'
						imgAll[i].style.display = 'block'
					}
				}
			}
		},
		j_getNewDetails(id) {
			return new Promise((resolve, reject) => {
				getNewsDetails(id).then((res) => {
					if (res.data.code == 200) {
						this.isEmpty = false
						this.data = res.data.data
						let dataContent = res.data.data.content
						dataContent = dataContent
							.replace(new RegExp('{', 'g'), '11')
							.replace(new RegExp('}', 'g'), '11')
							.replace(new RegExp('\\$', 'g'), '22')
						let txt = '2211' + '.' + '11'
						let rContent = dataContent.replace(
							new RegExp(txt, 'g'),
							window.baseUrl,
						)
						// this.content = res.data.data.content;
						document.getElementById('textCenter').innerHTML =
							rContent
						this.$nextTick(() => {
							this.init()
							document
								.getElementById('textCenter')
								.getElementsByClassName('ql-editor')[0]
								.setAttribute('contenteditable', false)
						})
						resolve()
					} else {
						reject()
					}
				})
			})
		},
	},
	destroyed() {},
}
</script>
<style lang="scss" scoped>
.newsDetails {
	.header {
		width: 100%;
		height: 64px;
		background-color: #232738;
	}
	.center,
	.left,
	.right {
		float: left;
	}
	.left,
	.right {
		width: var(--page-gutter);
		background-color: #fff;
	}
	.center {
		width: 100%;
	}
	.left {
		margin-left: -100%;
	}
	.right {
		margin-left: calc(0px - var(--page-gutter));
	}
	.inner {
		margin: 0 var(--page-gutter);
	}

	.content {
		margin-top: 60px;
		padding: 80px 0;
		min-height: 400px;
		::v-deep .el-breadcrumb {
			font-size: 18px;
			margin-bottom: 40px;
		}
		.content-text {
			font-size: 16px;
			.content-title {
				font-size: 52px;
				font-family: 'PingFang SC', 'Source Han Sans SC';
				font-weight: 500;
				color: #333333;
				line-height: 52px;
				text-align: center;
			}
			.content-txt {
				text-align: center;
				font-size: 16px;
				font-family: 'PingFang SC', 'Source Han Sans SC';
				font-weight: 400;
				color: #333333;
				line-height: 24px;
				margin: 40px 0;
				time {
					margin-right: 20px;
				}
			}
			#textCenter {
				text-align: left;
				text-indent: 2em;
				line-height: 130%;
				overflow: hidden;
				::v-deep .ql-editor {
					overflow: hidden;
				}
				::v-deep p {
					width: 100%;
					img {
						width: revert-layer;
						max-width: 90%;
						height: auto;
					}
				}
				.ql-toolbar {
					display: none !important;
				}
				.ql-container {
					border: 0;
				}
			}
		}
		.empty {
			width: 45%;
			height: 45%;
			margin: auto;
			position: relative;
			img {
				width: 100%;
				height: 100%;
				display: block;
			}
			span {
				width: 100%;
				display: inline-block;
				position: absolute;
				bottom: 20%;
				font-size: 18px;
				color: #666;
				text-align: center;
			}
		}
	}
}
img {
	display: block;
}

@media screen and (max-width: 768px) {
	.newsDetails {
		margin-bottom: 40px;
		.header {
			height: 44px;
		}
		.left,
		.right {
			width: 16px;
		}
		.right {
			margin-left: -16px;
		}
		.inner {
			margin: 0 16px;
		}
		.content {
			margin-top: 32px;
			padding: 0;
			min-height: auto;
			.content-text {
				font-size: 14px;
				.content-title {
					font-size: 18px;
					line-height: 26px;
				}
				.content-txt {
					font-size: 12px;
					line-height: 20px;
					margin: 12px 0;
					span {
						display: none;
					}
				}
				#textCenter {
					::v-deep .ql-editor {
						padding: 0;
					}
					img {
						width: revert-layer;
						max-width: 90%;
						height: auto;
						margin: 10px 0;
					}
					.ql-video {
						width: 80%;
						height: 80%;
						text-align: center;
					}
				}
			}
		}
	}
}
</style>
